import { render } from "./KitchenDisplay.vue?vue&type=template&id=25c87336&scoped=true"
import script from "./KitchenDisplay.vue?vue&type=script&lang=js"
export * from "./KitchenDisplay.vue?vue&type=script&lang=js"

import "./KitchenDisplay.vue?vue&type=style&index=0&id=25c87336&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c87336"]])

export default __exports__